import {Query} from "@datorama/akita";
import {UIState} from "./models";

export class UIQuery extends Query<UIState> {
    readonly modal$ = this.select('modalActive')
    readonly slug$ = this.select('slug');
}